import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Encabezado } from '../../Components/Encabezado/Encabezado'
import { RegistrarMenuListaEmpleadosTabs } from '../../Components/Cafetería/Tabs/RegistrarMenuListaEmpleadosTabs';

import { 
  fetchGetSemanaAlmuerzoActiva,
  selectSemanaAlmuerzoActiva
} from '../../redux/Cafeteria/CafeteriaSlice';

import { 
  fetchGetEmpleadosPorArea,
} from '../../redux/Cafeteria/CafeteriaSlice';

import { selectUserData } from '../../redux/Login/LoginSlice';

export const DigitarListadoMenuEmpleados = () => {

    // ? HOOK DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const { AreaOrganizacionalId = 0 } = useSelector(selectUserData);

    // ? HOOK-SELECTOR
    const semana = useSelector(selectSemanaAlmuerzoActiva);

    // ? HOOK-EFFECT
    useEffect(() => {
      dispatch(fetchGetSemanaAlmuerzoActiva());
    }, [])

    useEffect(() => {
      if(semana?.id > 0){
        dispatch(fetchGetEmpleadosPorArea({areaId: AreaOrganizacionalId, semanaId: semana.id}))
      }
    }, [AreaOrganizacionalId, semana])

  return (
    <Encabezado title={`Menú de Almuerzo - ${semana.semanaLabel}`}>
        <RegistrarMenuListaEmpleadosTabs />
    </Encabezado>
  )
}
